import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import type { IntegrationScope } from '../../../../models/integration-settings';
import type { Integration } from '../../../../models/integration-settings';

export const removeIntegrationAction = createAction(
  ActionTypes.REMOVE_INTEGRATION,
  props<{ payload: { scope: IntegrationScope, integration: Integration } }>()
);

export const removeIntegrationSuccessAction = createAction(
  ActionTypes.REMOVE_INTEGRATION_SUCCESS,
  props<{ data: [void, ...void[]] }>()
);

export const removeIntegrationFailureAction = createAction(
  ActionTypes.REMOVE_INTEGRATION_FAILURE,
  props<{ error: unknown }>()
);
